import React from 'react'

function ScroolTop() {
  return (
    <a className="border rounded d-inline scroll-to-top" href="#page-top">
        <i className="fas fa-angle-up"></i>
    </a>
  )
}

export default ScroolTop